import { CHAVES_CONFIGURACAO_PUBLICAS } from '@varga/shared';
import { z } from 'zod';
import { api } from '../lib/http';

// ── Recompensas (os 4 níveis do ciclo do indicador) ─────────────────────────
const recompensaSchema = z
  .object({
    id: z.string(),
    nivel: z.number().int(),
    descricao: z.string(),
    ativo: z.boolean(),
    custoEstimado: z
      .union([z.string(), z.number(), z.null()])
      .transform((v) => (v == null ? null : Number(v))),
  })
  .passthrough();
export type Recompensa = z.infer<typeof recompensaSchema>;

const recompensasSchema = z.object({ itens: z.array(recompensaSchema) });

export async function listarRecompensas(): Promise<Recompensa[]> {
  return (await api(recompensasSchema, '/v1/recompensas')).itens;
}

export function salvarRecompensa(
  nivel: number,
  dados: { descricao?: string; ativo?: boolean; custoEstimado?: number | null },
) {
  return api(recompensaSchema, `/v1/recompensas/${nivel}`, { method: 'PUT', body: dados });
}

// ── Configuração (chave/valor) ──────────────────────────────────────────────
const configItemSchema = z.object({ chave: z.string(), valor: z.string() }).passthrough();
export type ConfigItem = z.infer<typeof configItemSchema> & { publica: boolean };

const configSchema = z.object({ itens: z.array(configItemSchema) });

const PUBLICAS = new Set<string>(CHAVES_CONFIGURACAO_PUBLICAS);

export async function listarConfiguracao(): Promise<ConfigItem[]> {
  const r = await api(configSchema, '/v1/configuracao');
  return r.itens.map((i) => ({ ...i, publica: PUBLICAS.has(i.chave) }));
}

export function salvarConfiguracao(chave: string, valor: string) {
  return api(configItemSchema, `/v1/configuracao/${encodeURIComponent(chave)}`, {
    method: 'PUT',
    body: { valor },
  });
}
